import { render, staticRenderFns } from "./metricAssignments.vue?vue&type=template&id=16ad541e&scoped=true"
import script from "./metricAssignments.vue?vue&type=script&lang=js"
export * from "./metricAssignments.vue?vue&type=script&lang=js"
import style0 from "./metricAssignments.vue?vue&type=style&index=0&id=16ad541e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16ad541e",
  null
  
)

export default component.exports